import { render, staticRenderFns } from "./geral.vue?vue&type=template&id=0bb03bb1&scoped=true&"
import script from "./geral.vue?vue&type=script&lang=js&"
export * from "./geral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb03bb1",
  null
  
)

export default component.exports